// src/firebase/firebaseConfig.js
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
const firebaseConfig = {
 apiKey: "AIzaSyAmKDdkTMsUKbHQNMsIqAV2e4D3rrXlqN0",
  authDomain: "groomberry-c0c80.firebaseapp.com",
  projectId: "groomberry-c0c80",
  storageBucket: "groomberry-c0c80.firebasestorage.app",
  messagingSenderId: "1044040719389",
  appId: "1:1044040719389:web:2d0a4f24f7cdb45b283af4",
  measurementId: "G-0V8QKVW2F1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firebase services
const auth = getAuth(app);
const db = getFirestore(app);
const googleProvider = new GoogleAuthProvider(); // ✅ Add this

export { auth, db, googleProvider }; // ✅ Export it
